module.exports = __webpack_public_path__ + "img/MeterWorkOrders-Office_lg.9c0b1ef6.png";